/*
 * Copyright (c) 2021 brightlamp
 */

import { axiosInit } from './axiosSetup';

export default {
    namespaced: true,
    state:
    {
        totalUnviewedMessages: 0,
        totalMessages: 0,
        messages: [],
        categories:
        {
            0: 'N/A', 1: 'Urgent', 2: 'Education', 3: 'General'
        }
    },
    mutations:
    {
        CLEAR_MESSAGES(state)
        {
            state.messages = []
        },
        SET_MESSAGES: (state, payload) =>
        {
            state.messages = payload;
            state.totalMessages = payload.length
        },
        SET_TOTAL_MESSAGES: (state, payload) =>
        {
            state.totalMessages = payload
        },
        UPDATE_MESSAGE_VIEWED_LOCALLY: (state, payload) =>
        {
            for (let message of state.messages)
            {
                if (message.source_id === payload)
                {
                    message.beenViewed = true;
                    state.totalUnviewedMessages = state.totalUnviewedMessages > 0 ? state.totalUnviewedMessages - 1: state.totalUnviewedMessages;
                    return
                }
            }
        },
        SET_TOTAL_UNVIEWED_MESSAGES: (state, payload) =>
        {
            state.totalUnviewedMessages = payload
        }
    },
    actions:
    {
        UPSERT_MESSAGE: async (context, payload) =>
        {
            const axios = await axiosInit();
            await axios.post('/user/message', payload)
        },
        GET_MESSAGES: async (context, payload) =>
        {
            const { page, itemsPerPage } = payload.pagination;
            const axios = await axiosInit();
            const response = await axios.get('/user/message',
     {
                params:
                {
                    messageType: payload.adminMode ? 'source' : 'destination',
                    subject: payload.search,
                    page: page,
                    limit: -1 === itemsPerPage ? 2147483647 : itemsPerPage
                }
            });
            getMessages(context, response);
            context.commit('SET_TOTAL_MESSAGES', response.headers['max-count'] * 1)
        },
        SET_MESSAGE_VIEWED_NO_WAIT: async (context, payload) =>
        {
            const axios = await axiosInit();
            axios.post(`/user/message/${payload}`).catch()
        },
        GET_UNVIEWED_MESSAGE_COUNT: async (context) =>
        {
            const axios = await axiosInit();
            const response = await axios.get('/user/message/unviewed')
            context.commit('SET_TOTAL_UNVIEWED_MESSAGES', response.headers['unviewed-message-count'] * 1)
        },
        DELETE_MESSAGE: async (context, payload) =>
        {
            const axios = await axiosInit();
            await axios.delete(`/user/message/${payload.source_id}`,
     {
                params:
                {
                    messageType: payload.adminMode ? 'source' : 'destination'
                }
            })
        }
    }
}

function getMessages(context, response)
{
    const messages = response.data;
    for (let message of messages)
    {
        message = getMessage(message, context)
    }
    context.commit('SET_MESSAGES', messages)
}

function getMessage(message, context)
{
    message.updatedAt = new Date(message.updatedAt).toLocaleString();
    message.categoryText = context.state.categories[message.category];
    return message
}